import React from 'react'
// import AssetAnalysisreport from '../../components/reports/assetReport/AssetAnalysisreport'
import AssetAnalysisreport from '../../../components/reports/assetReport/AssetAnalysisreport'

function AssetAnalysis() {
    return (
        <>
                        {/*Dynamic content goes here */}
                        <AssetAnalysisreport />
  
        </>
    )
}  

export default AssetAnalysis;